import React, { useEffect, useRef, useState } from "react";
//import SriyanshCardHeader from "../../../components/CardHeader";
import { Card, CardContent } from "@mui/material";
//import { BoxStyle } from "../../../constantVaribles/constatanvariable";
//import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import DropdownfromDatabaseList from "../../../CustomComponant/DropdownfromDatabaseList";
//import DatePickerComponent from "../../../CustomComponant/DateTimePickerField";
import PoReport from "../Po/PoReport";
import apiClient from "../../../BaseUrl/apiClient.js";
import { useAuthentication } from "../../../customHook/useAuthentecation";
import { USER_RIGHTS } from "../../../constants/constants";
import TokenService from "../../../service/TokenService";
import CircularProgress from "@mui/material/CircularProgress";

const GeneralReports = () => {
  const reportRef = useRef(null);
  const { auth } = useAuthentication();
  const tokenServiceDetails = TokenService.getUserDetails();
  const consigee_consignee = tokenServiceDetails?.consignee;
  const [consignee, setconsignee] = useState("");
  const [consignees, setconsignees] = useState([]);
  // const today = dayjs();

  const [reports, setreports] = useState([]);
  const [report, setreport] = useState("");
  const [subreport, setsubreport] = useState("");
  const [subreports, setsubreports] = useState([]);

  const [generateReportClick, setgenerateReportClick] = useState(false);

  // const [dateFrom, setdateFrom] = useState(dayjs());
  // const [dateTo, setdateTo] = useState(dayjs());

  const [pageLoader, setPageLoader] = useState(false);

  // Function to get the key based on the selected value

  const reportgenerateClick = (event) => {
    setgenerateReportClick(true);
  };

  const navigate = useNavigate();
  // Function to fetch Consignee from the API

  const fetchConsignees = async () => {
    try {
      //setPageLoader(true);
      const response = await apiClient.post("/ConsigneeList", {
        /* request payload if needed */
      });
      setconsignees(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    } finally {
      setPageLoader(false);
    }
  };

  // Function to fetch Consignee from the API
  const fetchReportList = async () => {
    try {
      const response = await apiClient.post("/ReportsList", {
        /* request payload if needed */
      });
      setreports(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const fetchsubReportList = async () => {
    try {
      const response = await apiClient.post("/subReportsList", {
        /* request payload if needed */
      });
      setsubreports(response.data);

      // Assuming response.data is an array of roles
      //console.log(response.data);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    fetchConsignees();
    fetchReportList();
    fetchsubReportList();
  }, []);

  useEffect(() => {
    // Update state if roles change (in case roles are updated dynamically)
    if (consignees.length > 0) {
      if (auth?.userrights === USER_RIGHTS.CONSIGNEE) {
        setconsignee(consigee_consignee);
      } else {
        setconsignee(consignees[0].ConsigneeCode);
      }
    }

    if (reports.length > 0) {
      setreport(reports[0].reportcode);
    }

     if (subreports.length > 0) {
      setsubreport("All Data");
     }
  }, [consignees, reports, subreports,auth?.userrights,consigee_consignee]);

  const handleClose = () => {
    navigate("/../dashboard", { replace: true });
  };

  const reportData = {
    consignee: consignee,
    reporttype: report,
    reportsubtype: subreport,
  };
  useEffect(() => {
    // Reset the report display when report or subreport changes
   
    setgenerateReportClick(false);

   

  }, [report, consignee]);


  useEffect(() => {
    if (generateReportClick && reportRef.current) {
      reportRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [generateReportClick]);


  return (
    <div >
      {/* <SriyanshCardHeader Title="Admin Reports" /> */}

      <Card className="Formcard">
      <div className="input-groupHeading">
      Admin Reports

            </div>
        <CardContent>
         <div className="row p-2" >
            {pageLoader ? (
              <div className="loaderContainer">
                {" "}
                <CircularProgress />{" "}
              </div>
            ) : (
              <div className="container">
                <div className="input-group">
                  <DropdownfromDatabaseList
                    Options={consignees}
                    option={consignee}
                    setOptionValue={setconsignee}
                    DisplayItem1="Shop"
                    DisplayItem2="ConsigneeCode"
                    showKeyInLabel={true}
                    disableLabel="Select Consignee from List"
                    allDataLabel="Select All"
                    disabled={auth?.userrights === USER_RIGHTS.CONSIGNEE} // disabled is true if user is not equal to "user"
                  />
                </div>
                <div className="input-group">
                  <DropdownfromDatabaseList
                    Options={reports}
                    option={report}
                    setOptionValue={setreport}
                    DisplayItem1="reporttype"
                    DisplayItem2="reportcode"
                    disableLabel="Select Report from List"
                    //allDataLabel="Select All"
                  />
                </div>
              </div>
            )}

            <div className="container">
              <div className="input-group">
                <DropdownfromDatabaseList
                  Options={subreports.filter(
                    (subreport) => subreport.mainreport === report
                  )}
                  option={subreport}
                  setOptionValue={setsubreport}
                  DisplayItem1="subreporttype"
                  DisplayItem2="reportid"
                  disableLabel="Select Sub Report from List"
                  //allDataLabel="Select All"
                />
              </div>

              <div className="input-group"></div>
            </div>

            <div className="col-6 "></div>

            {/* {daterangeselected && (
              <>
                <div className="container">
                  <div className="input-group">
                    <DatePickerComponent
                      label="Report Generate from Date"
                      id="datefrom"
                      value={dateFrom}
                      onChange={setdateFrom}
                      maxDate={today}
                    />
                  </div>

                  <div className="input-group">
                    <DatePickerComponent
                      label="Report Generate to Date"
                      id="dateto"
                      value={dateTo}
                      onChange={setdateTo}
                      maxDate={today}
                    />
                  </div>
                </div>
              </>
            )} */}
          </div>

          <>
            <div
              className="flex container"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={reportgenerateClick}
                title="Click forReport Generate"
                disabled={generateReportClick}
              >
                Generate Report
              </button>

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close Report
              </button>
            </div>
          </>

          {generateReportClick && (
            <>
              <div id="report"  ref={reportRef}>
                <PoReport
                  consignee={reportData.consignee}
                  reporttype={reportData.reporttype}
                  reportsubtype={reportData.reportsubtype}
                />
              </div>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default GeneralReports;
